import React from 'react';
import FloatingLabel from "floating-label-react";
import "floating-label-react/styles.css";
import { Input, InputGroup, InputGroupAddon, InputGroupText, Button } from "reactstrap";

const InputNumber = (props) => {
    // Handle key press to only allow numeric input
    const handleKeyPress = (e) => {
        // Allow: backspace, delete, tab, escape, enter, and numbers 0-9
        if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Tab' || 
            e.key === 'Escape' || e.key === 'Enter' || /[0-9]/.test(e.key)) {
            return;
        }
        // Prevent any other key press
        e.preventDefault();
    };

    return (
        <div>
            <FloatingLabel
                id={props.name}
                name={props.name}
                placeholder={props.label}
                className="custom-class ebw-form__input"
                type="tel"
                maxLength={10}
                inputMode="numeric"
                pattern="[0-9]*"
                value={props.value}
                onChange={props.changeEvent}
                onKeyPress={handleKeyPress}
            />
            {props.error && <p className="ebw-error mt-2">{props.error}</p>}
        </div>
    );
}
export default InputNumber;


//- Number Input for Payment Cards
export const InputPaymentCard = (props) => {
    return (
        <>
            <InputGroup className="ebw-tab__filter-group mb-3">
                <Input
                    type="number"
                    name={props.name}
                    id={props.id}
                    value={props.value}
                    placeholder={props.label}
                    className="ebw-form__input ebw-form__input-payment ebw-form__input-select--category text-sm"
                />

                <InputGroupAddon addonType="append" className="ebw-tab__filter-groupaddon">
                    <InputGroupText className="ebw-tab__filter-grouptext p-0 bg-transparent">
                        <div className="bg-transparent ebw-tab__filter-search--paymentcard mr-3">
                            <span className="ebw-icon ebw-icon--lg icon-credit-card ebw-tab__filter-icon"></span>
                        </div>
                    </InputGroupText>
                </InputGroupAddon>
            </InputGroup>
        </>
    )
}